export default __webpack_public_path__ + "static/media/holiday_inn_image.1401d2d4.jpg";